import api, { buildURLWithParams } from '@/services/api';

import {
  type RoadmapDefaultResourceAllocationDTO,
  type RoadmapResource,
  type RoadmapResourceYearDTO,
  type RoadmapResourceYearEditDTO,
} from '../types';

const BASE_URL = 'resources';

export const getResourcesGroups = async ({ year, includeDeleted }: { year?: number; includeDeleted?: boolean }) => {
  return await api.get<RoadmapResource[]>(buildURLWithParams(BASE_URL, { year, includeDeleted }));
};

export const getRoadmapDefaultResourceAllocations = async () => {
  return await api.get<RoadmapDefaultResourceAllocationDTO[]>(`${BASE_URL}/default-allocations`);
};

export const getRoadmapResourceYearByYear = async (year: number) => {
  return await api.get<RoadmapResourceYearEditDTO[]>(`${BASE_URL}/year/${year}`);
};

export const getRoadmapResourceYearByResource = async (resourceId: number) => {
  return await api.get<RoadmapResourceYearDTO[]>(`${BASE_URL}/${resourceId}/year`);
};

export const updateResourceYear = async (year: number, payload: RoadmapResourceYearEditDTO[]) => {
  await api.put(`${BASE_URL}/year/${year}`, payload);
};

export const deleteResource = async (id: number) => {
  await api.delete(`${BASE_URL}/${id}`);
};

export const updateResource = async (payload: RoadmapResource) => {
  await api.put(BASE_URL, payload);
};

export const restoreResources = async (ids: number[]) => {
  await api.put(`${BASE_URL}/restore`, ids);
};

export const createResource = async (payload: RoadmapResource) => {
  await api.post(BASE_URL, payload);
};

export const getResource = async (id: number) => {
  return await api.get<RoadmapResource>(`${BASE_URL}/${id}`);
};

export const getRoadmapResourcesByUser = async () => {
  return await api.get<RoadmapResource[]>(`${BASE_URL}/user`);
};
